import elTreeSelect from '@/components/elTreeSelect/index'
import ChooseCateringFlavorDialog from '@/components/ChooseCateringFlavorDialog/index'
const tip = {}
tip.install = function(vue) {
  vue.component('el-tree-select', elTreeSelect)
  vue.component('choose-catering-flavor-dialog', ChooseCateringFlavorDialog)
}
export default tip
